import { FetchSkillsFrameworkMatchingProfileSkillsParams } from "PFCore/services/skills_frameworks/fetch_skills_framework_matching_profile_skills";
import { FetchSkillsFrameworksOptionsParams } from "PFCore/services/skills_frameworks/fetch_skills_frameworks_options";
import { Id } from "PFTypes/id";
import { QueryParams } from "PFTypes/query_params";

export const skillsFrameworksKeys = {
  all: () => ["skillsFrameworks"],
  list: (params: QueryParams = {}) => [...skillsFrameworksKeys.all(), "list", params],
  single: (id: Id) => [...skillsFrameworksKeys.all(), String(id)],
  options: (params: FetchSkillsFrameworksOptionsParams = {}) => [
    ...skillsFrameworksKeys.all(),
    "options",
    params
  ],
  matchingProfileSkills: (params: FetchSkillsFrameworkMatchingProfileSkillsParams) => [
    ...skillsFrameworksKeys.all(),
    "matchingProfileSkills",
    params
  ]
};
